import { render, staticRenderFns } from "./UnmatchItem.vue?vue&type=template&id=0ae58786&"
import script from "./UnmatchItem.vue?vue&type=script&lang=js&"
export * from "./UnmatchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae58786')) {
      api.createRecord('0ae58786', component.options)
    } else {
      api.reload('0ae58786', component.options)
    }
    module.hot.accept("./UnmatchItem.vue?vue&type=template&id=0ae58786&", function () {
      api.rerender('0ae58786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/financial/reconciliation/santander/pix/components/UnmatchItem.vue"
export default component.exports